module.exports = __webpack_public_path__ + "img/advocate_white.88808109.svg";